import PropTypes from "prop-types";
import { createContext } from "react";
import useJourneys from "../hooks/use-journeys";
import useJourneysContactFilters from "../hooks/use-journey-contact-filters";

const JourneysContext = createContext(() => {});

const JourneysProvider = ({ children }) => {
  const state = useJourneys();
  const filters = useJourneysContactFilters(state.selectedJourney);

  return <JourneysContext.Provider value={{ ...state, ...filters }}>{children}</JourneysContext.Provider>;
};

JourneysProvider.propTypes = {
  children: PropTypes.any,
};

export { JourneysProvider, JourneysContext };
